import { useLogin } from "@refinedev/core";
import { Button, Form, Input, Typography } from "antd";
import { Link } from "react-router";

import { AuthCard } from "./auth-card";

type PasswordValues = { email: string; password: string };
type CodeValues = { code: string };

// Failed attempts are shown by Refine's notification (the auth provider's Turkish message).

export function LoginPage() {
  const { mutate, isPending } = useLogin<PasswordValues>();
  return (
    <AuthCard title="Giriş yap">
      <Form<PasswordValues>
        layout="vertical"
        requiredMark={false}
        onFinish={(values) => mutate(values)}
      >
        <Form.Item
          label="E-posta"
          name="email"
          rules={[{ required: true, type: "email", message: "Geçerli bir e-posta adresi gir." }]}
        >
          <Input autoComplete="username" autoFocus />
        </Form.Item>
        <Form.Item
          label="Şifre"
          name="password"
          rules={[{ required: true, message: "Şifreni gir." }]}
        >
          <Input.Password autoComplete="current-password" />
        </Form.Item>
        <Button type="primary" htmlType="submit" block loading={isPending}>
          Devam
        </Button>
      </Form>
    </AuthCard>
  );
}

/** Second step: the 6-digit code from the authenticator app. */
export function TwoFactorLoginPage() {
  const { mutate, isPending } = useLogin<CodeValues>();
  return (
    <AuthCard title="Doğrulama kodu">
      <Typography.Paragraph type="secondary">
        Authenticator uygulamandaki 6 haneli kodu gir.
      </Typography.Paragraph>
      <Form<CodeValues>
        layout="vertical"
        requiredMark={false}
        onFinish={(values) => mutate(values)}
      >
        <Form.Item
          label="Kod"
          name="code"
          rules={[{ required: true, pattern: /^\d{6}$/, message: "6 haneli kodu gir." }]}
        >
          <Input inputMode="numeric" autoComplete="one-time-code" maxLength={6} autoFocus />
        </Form.Item>
        <Button type="primary" htmlType="submit" block loading={isPending}>
          Giriş yap
        </Button>
      </Form>
      <Typography.Paragraph style={{ marginTop: 16, marginBottom: 0 }}>
        <Link to="/login">Başka bir hesapla giriş yap</Link>
      </Typography.Paragraph>
    </AuthCard>
  );
}
